import { t } from '@transifex/native';

import { getGmtStrings, validateTimeZone } from 'pkg/timezone';

import MaterialSymbol, { IconSizeMap } from 'components/material-symbols';

import * as Input from 'components/form/inputs';
import type { SimpleAutoCompleteSuggestion } from 'components/form/inputs/simple_autocomplete';
import SimpleAutoComplete from 'components/form/inputs/simple_autocomplete';
import Row from 'components/layout/row';

interface TimeZoneSelectProps {
	timezone: string;
	label?: string;
	autoFocus?: boolean;
	onSelect: (value: string) => void;
	onBlur?: () => void;
}

export function TimeZoneSelect({
	timezone,
	label,
	autoFocus = false,
	onSelect,
	onBlur,
}: TimeZoneSelectProps) {
	const suggestions: SimpleAutoCompleteSuggestion = {
		items: getGmtStrings(),
		label: t('Time zone'),
		onSelect: (tz: string) => onSelect(tz),
		renderWith: (item: string) => (
			<Row columns="auto 1fr" align="center">
				<MaterialSymbol variant="schedule" size={IconSizeMap.default} />
				<span>{item}</span>
			</Row>
		),
	};

	const handleBlur = () => {
		if (onBlur && timezone && validateTimeZone(timezone)) {
			onBlur();
		}
	};

	const validate = (timezone: string) => {
		if (
			(timezone.length > 0 && !validateTimeZone(timezone)) ||
			timezone.length === 0
		) {
			return false;
		}

		return true;
	};

	return (
		<SimpleAutoComplete
			name="timezone"
			label={label}
			autoFocus={autoFocus}
			defaultValue={timezone}
			validate={validate}
			placeholder={t('Select time zone')}
			suggestions={suggestions}
			onBlur={handleBlur}>
			<Input.Prefix inline>
				<MaterialSymbol variant="search" size={IconSizeMap.default} />
			</Input.Prefix>
		</SimpleAutoComplete>
	);
}
